module.exports = __webpack_public_path__ + "img/cartoesP1.92a90309.png";